module.exports = __webpack_public_path__ + "fonts/font.8af3eb8.woff2";